import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SmartQuestions from 'careiq/ui/smartquestions';

const SmartQuestionsShareModal = ({ open, onClose, data }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md" // Adjust to 'md' or 'xl' as needed
      PaperProps={{ style: { backgroundColor: '#f9fafb', borderRadius: '8px' } }}
    >
      <div className="p-4 flex justify-between items-center bg-white border-b">
        <h2 className="text-xl font-semibold text-blue-800">Smart Questions Share View</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>

      <DialogContent dividers className="p-4">
        <div className="max-w-6xl mx-auto">
          <SmartQuestions view={1} data={data} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SmartQuestionsShareModal;
